import React, { useContext, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import useIsVisible from '@aytm/lib/hooks/useIsVisible'

import { DataContext } from '@aytm/app/stats/page/sidebar/coding/CodingPanel'

import SettingsDropdown from '@aytm/app/stats/page/sidebar/coding/components/SettingsDropdown'

import Portal from '@aytm/lib/rfd-ui/components/basic/portal'
import ClickOutside from '@aytm/lib/rfd-ui/components/basic/click-outside'

import style from '@aytm/app/stats/page/sidebar/coding/styles/CodingPanel.module.scss'

const PORTAL_ID = 'oe-coding-settings-portal'

const SettingsButton = ({
  itemRef,
  options,
  warning,
  opened = false,
  isEditing = false,
  isProcessing = false,
  isCurrentProcessing = false,
  onActionCancel,
  onToggle
}) => {
  const { root, onClickOutside } = useContext(DataContext)

  const buttonRef = useRef(null)

  const isVisible = useIsVisible(opened && buttonRef && buttonRef.current ? buttonRef : null)

  useEffect(() => {
    if (!opened) onActionCancel()
  }, [opened, onActionCancel])

  useEffect(() => {
    if (!isEditing) onActionCancel()
  }, [isEditing, onActionCancel])

  return (
    <div
      className={classNames(style['component-settings'], {
        [style['component-settings-opened']]: opened,
        [style['component-settings-processing']]: isCurrentProcessing
      })}
    >
      {isCurrentProcessing ? (
        <span className={style['component-settings-icon']}>
          <i className="icon-aytmfd-refresh-v2 aytmfd-spin" />
        </span>
      ) : isProcessing ? null : (
        <>
          <span ref={buttonRef} className={style['component-settings-icon']} onClick={onToggle}>
            <i className="icon-aytmfd-config" />
          </span>

          {opened ? (
            <Portal nodeID={PORTAL_ID}>
              <ClickOutside
                onClickOutside={event => {
                  if (buttonRef.current.contains(event.target) || buttonRef.current.isEqualNode(event.target)) return

                  onClickOutside()
                }}
              >
                {isVisible ? (
                  <SettingsDropdown
                    root={root}
                    itemRef={itemRef}
                    buttonRef={buttonRef}
                    options={options}
                    warning={warning}
                  />
                ) : null}
              </ClickOutside>
            </Portal>
          ) : null}
        </>
      )}
    </div>
  )
}

SettingsButton.propTypes = {
  itemRef: PropTypes.any,
  options: PropTypes.array,
  warning: PropTypes.string,
  opened: PropTypes.bool,
  isEditing: PropTypes.bool,
  isProcessing: PropTypes.bool,
  isCurrentProcessing: PropTypes.bool,
  onActionCancel: PropTypes.func,
  onToggle: PropTypes.func
}

SettingsButton.displayName = 'SettingsButton'

export default SettingsButton
